export default {
	options: [{
		value: '3',
		label: '未联系'
	}, {
		value: '4',
		label: '无意向'
	}, {
		value: '5',
		label: '意向一般'
	}, {
		value: '6',
		label: '意向明确'
	}, {
		value: '7',
		label: '已合作'
	}],
	optionsAll: [{
		value: '0',
		label: '全部'
	},
	{
		value: '3',
		label: '未联系'
	}, {
		value: '4',
		label: '无意向'
	}, {
		value: '5',
		label: '意向一般'
	}, {
		value: '6',
		label: '意向明确'
	}, {
		value: '7',
		label: '已合作'
	}
	],
	apiRoot: {
		'114': {
			// Title: '贝玛教育',
			// Name: '',
			// Logo: 'logo-beima.png',
			// LoginBg: 'login-beima.png',
			// Color: 'da2337',
			// RequestUnit: 'IsBeiMa'
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		},
		'tice': {
			Title: '雏鹰',
			Name: '雏鹰体测',
			Logo: 'logo-chuying.png',
			LoginBg: 'login-chuying.png',
			Color: 'da2337',
			RequestUnit: 'IsChuYing'
		},
		'admin': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		},
		'atest': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		},
		'ra': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
		},
		'fangcao': {
			Title: '芳草教育',
			Name: '',
			Logo: 'logo-fangcao.png',
			LoginBg: 'login-fangcao.png',
			Color: '14A83B',
			RequestUnit: 'IsFangCao'
		},
		'61park': {
			Title: '贝玛教育',
			Name: '',
			Logo: 'logo-beima.png',
			LoginBg: 'login-beima.png',
			Color: 'da2337',
			RequestUnit: 'IsBeiMa'
		},
		// 'localhost:8099': {
		// 	// Title: '芳草教育',
		// 	// Name: '',
		// 	// Logo: 'logo-fangcao.png',
		// 	// LoginBg: 'login-fangcao.png',
		// 	// Color: '14A83B',
		// 	// RequestUnit: 'IsFangCao'
		// 	Title: '睿莱',
		// 	Name: '睿莱体测',
		// 	Logo: 'logo.png',
		// 	LoginBg: 'login.png',
		// 	Color: 'da2337',
		// 	RequestUnit: 'IsAReliable'
		// },
		'axs': {
			// Title: '芳草教育',
			// Name: '',
			// Logo: 'logo-fangcao.png',
			// LoginBg: 'login-fangcao.png',
			// Color: '14A83B',
			// RequestUnit: 'IsFangCao'
			Title: '艾秀星',
			Name: '',
			Logo: 'logo-aixiuxing.png',
			LoginBg: 'login-aixiuxing.png',
			Color: 'da2337',
			RequestUnit: 'IsAixiuxing'
		},
		'localhost:8099': {
			Title: '睿莱',
			Name: '睿莱体测',
			Logo: 'logo.png',
			LoginBg: 'login.png',
			Color: 'da2337',
			RequestUnit: 'IsAReliable'
			// Title: '艾秀星',
			// Name: '',
			// Logo: 'logo-aixiuxing.png',
			// LoginBg: 'login-aixiuxing.png',
			// Color: 'da2337',
			// RequestUnit: 'IsAixiuxing'
		}
	},

	//幼儿筛选
	genderType: {
		'1': '男',
		'2': '女'
	},
	rankType: {
		'0': '需努力',
		'1': '需努力',
		'2': '较差',
		'3': '合格',
		'4': '良好',
		'5': '优秀',
	},
	weightRank: {
		"-1": "偏轻",
		"-3": "偏轻",
		'5': "正常",
		'3': "偏胖",
		'1': "肥胖"
	},
	classType: {
		'10': '大班',
		'11': '中班',
		'12': '小班',
		'13': '托班',
		'14': '混龄班',
		'15': '学前班',
	},
	classTypeSVG: {
		'10': '大班',
		'11': '中班',
		'12': '小班',
		'13': '托班',
		'14': '混龄班',
		'15': '学前班',
		'90': '全园平均',
		'99': '全国平均',
	},
	missTypeVal: {
		'0': '已测完',
		'undefined': '未测试',
		'1': '测试中',
		'2': '因故缺席',
		'4': '未测试'
	},

	projectType: {
		'12': {
			Name: '身高',
			Score: 'HeightScore',
			Rank: 'HeightRank',
			Unit: 'cm'
		},
		'13': {
			Name: '体重',
			Score: 'WeightScore',
			Rank: 'WeightRank',
			Unit: 'kg'
		},
		'14': {
			Name: '坐位体前屈',
			Score: 'SitReachScore',
			Rank: 'SitReachRank',
			Unit: 'cm'
		},
		'15': {
			Name: '立定跳远',
			Score: 'BroadJumpScore',
			Rank: 'BroadJumpRank',
			Unit: 'cm'
		},
		'16': {
			Name: '双脚连续跳',
			Score: 'DoubleJumpScore',
			Rank: 'DoubleJumpRank',
			Unit: 's'
		},
		'17': {
			Name: '十米折返跑',
			Score: 'ShuttleRunScore',
			Rank: 'ShuttleRunRank',
			Unit: 's'
		},
		'18': {
			Name: '网球掷远',
			Score: 'ThrowScore',
			Rank: 'ThrowRank',
			Unit: 'm'
		},
		'19': {
			Name: '走平衡木',
			Score: 'BalanceScore',
			Rank: 'BalanceRank',
			Unit: 's'
		},
		'20': {
			Name: '运动能力',
			Score: 'SportAbiltyScore',
			Rank: 'SportAbility',
			Unit: 's'
		}
	},


	totalRankOptions: [{
		value: '0',
		label: '全部'
	}, {
		value: '1',
		label: '需努力'
	}, {
		value: '2',
		label: '合格'
	}, {
		value: '3',
		label: '良好'
	}, {
		value: '4',
		label: '优秀'
	}],
	testTypeOptions: [{
		value: '-99',
		label: '全部'
	}, {
		value: '0',
		label: '已测试'
	}, {
		value: '1',
		label: '测试中'
	}, {
		value: '2',
		label: '因故缺席'
	}, {
		value: '3',
		label: '未测试'
	}],
	genderOptions2: [{
		value: '0',
		label: '全部'
	}, {
		value: '1',
		label: '男'
	}, {
		value: '2',
		label: '女'
	}],
	projectIdOptions2: [{
		value: '0',
		label: '全部'
	}, {
		value: '12',
		label: '身高'
	}, {
		value: '13',
		label: '体重'
	}, {
		value: '14',
		label: '柔韧性（坐位体前屈）'
	}, {
		value: '15',
		label: '下肢力量（立定跳远）'
	}, {
		value: '16',
		label: '协调性（双脚连续跳）'
	}, {
		value: '17',
		label: '灵敏性（十米折返跑）'
	}, {
		value: '18',
		label: '上肢力量（网球掷远）'
	}, {
		value: '19',
		label: '平衡力（平衡木）'
	},
	{
		value: '20',
		label: '运动能力'
	}],
	projectIdOptions: [{
		value: '0',
		label: '全部'
	}, {
		value: '12',
		label: '身高'
	}, {
		value: '13',
		label: '体重'
	}, {
		value: '14',
		label: '柔韧性（坐位体前屈）'
	}, {
		value: '15',
		label: '下肢力量（立定跳远）'
	}, {
		value: '16',
		label: '协调性（双脚连续跳）'
	}, {
		value: '17',
		label: '灵敏性（十米折返跑）'
	}, {
		value: '18',
		label: '上肢力量（网球掷远）'
	}, {
		value: '19',
		label: '平衡力（平衡木）'
	},
	],
	//将1-需努力和2-较差合并为 需努力
	projectRankOptions: [{
		value: '0',
		label: '全部'
	}, {
		value: '2',
		label: '需努力'
	}, {
		value: '3',
		label: '合格'
	}, {
		value: '4',
		label: '良好'
	}, {
		value: '5',
		label: '优秀'
	}],
	gradeOptions: [{
		value: '0',
		label: '全部'
	}, {
		value: '10',
		label: '大班'
	}, {
		value: '11',
		label: '中班'
	}, {
		value: '12',
		label: '小班'
	}, {
		value: '13',
		label: '托班'
	}, {
		value: '14',
		label: '混龄班'
	}, {
		value: '15',
		label: '学前班'
	}],
	classIdOptions: [{
		value: '0',
		label: '全部'
	}],
	resetSearchForm: {
		TotalRank: '0',
		TestType: '-99',
		Gender: '0',
		ProjectId: '0',
		ProjectRank: '0',
		Grade: '0',
		ClassId: '0'
	},


	//家长报告
	//雷达图  对话框
	divClass: [
		'top-right',
		'middle1-right',
		'middle2-right',
		'bottom-right',
		'bottom-left',
		'middle2-left',
		'middle1-left',
		'top-left'
	],
	//雷达图  icon图片
	iconClass: [
		'top-right-icon',
		'middle1-right-icon',
		'middle2-right-icon',
		'bottom-right-icon',
		'bottom-left-icon',
		'middle2-left-icon',
		'middle1-left-icon',
		'top-left-icon'
	],
	//雷达图  icon 三角形 图片
	iconArrowClass: [
		'top-right-arrow-icon',
		'middle1-right-arrow-icon',
		'middle2-right-arrow-icon',
		'bottom-right-arrow-icon',
		'bottom-left-arrow-icon',
		'middle2-left-arrow-icon',
		'middle1-left-arrow-icon',
		'top-left-arrow-icon'
	],

	// 54优良  3中 21差：
	evaluate: {
		5: {
			rank: '优秀',
			backgroud: '#edf7fd',
			txt: '孩子表现的很好，继续保持。'
		},
		4: {
			rank: '良好',
			backgroud: '#edf7fd',
			txt: '孩子表现的很好，继续保持。'
		},
		3: {
			rank: '合格',
			backgroud: '#edf7fd',
			txt: '孩子表现还不错，继续努力。'
		},
		2: {
			rank: '需努力',
			backgroud: '#f8e8ea',
			txt: '孩子表现不是很理想，家长需多关注。'
		},
		1: {
			rank: '需努力',
			backgroud: '#f8e8ea',
			txt: '孩子表现不是很理想，家长需多关注。'
		},
		0: {
			rank: '需努力',
			backgroud: '#f8e8ea',
			txt: '孩子表现不是很理想，家长需多关注。'
		},
	},
	//课程名对应课程的素质
	majorPhysicalFitnessId: {
		1: '灵敏',
		2: '平衡',
		3: '协调',
		4: '柔韧',
		5: '上肢',
		6: '下肢'
	},
	//授课教程素质模板
	courseQuality: [
		{
			name: 'Association',
			lable: '同伴交往'
		},
		{
			name: 'RuleConsciousness',
			lable: '规则意识'
		},
		{
			name: 'Teamwork',
			lable: '团队协作'
		},
		{
			name: 'Competitive',
			lable: '竞争意识'
		},
		{
			name: 'ExerciseHabit',
			lable: '运动习惯'
		}
	],
	//授课教程身体素质数组
	coursePhysicalQuality: [
		{
			name: 'Balance',
			lable: '平衡'
		},
		{
			name: 'Coordinate',
			lable: '协调'
		},
		{
			name: 'Sensitive',
			lable: '灵敏'
		},
		{
			name: 'Flexible',
			lable: '柔韧'
		},
		{
			name: 'UpperLimbStrength',
			lable: '上肢力量'
		},
		{
			name: 'LowerLimbStrength',
			lable: '下肢力量'
		}
	],
	//感知觉数组
	gameSensePerception: [
		{
			name: 'Direction',
			lable: '方向'
		},
		{
			name: 'Altitude',
			lable: '高度'
		},
		{
			name: 'Heft',
			lable: '重量'
		},
		{
			name: 'Gravity',
			lable: '重力'
		},
		{
			name: 'Space',
			lable: '空间'
		},
		{
			name: 'Colour',
			lable: '颜色'
		},
		{
			name: 'Form',
			lable: '形状'
		},
		{
			name: 'Longness',
			lable: '长度'
		},
		{
			name: 'Proprioception',
			lable: '本体感觉'
		}
	],
	//授课教案报告模板
	coursePurpose: [
		{
			name: 'Walk',
			lable: '走',
			type: '1'
		},
		{
			name: 'Run',
			lable: '跑',
			type: '1'
		},
		{
			name: 'ObstacleRun',
			lable: '障碍跑',
			type: '1'
		},
		{
			name: 'ReverseRun',
			lable: '变向跑',
			type: '1'
		},
		{
			name: 'Hop',
			lable: '单脚跳',
			type: '1'
		},
		{
			name: 'SkipJump',
			lable: '双脚跳',
			type: '1'
		},
		{
			name: 'StepJump',
			lable: '跨跳',
			type: '1'
		},
		{
			name: 'Bore',
			lable: '钻',
			type: '1'
		},
		{
			name: 'SideDrill',
			lable: '侧身钻',
			type: '1'
		},
		{
			name: 'FrontDrill',
			lable: '正面钻',
			type: '1'
		},
		{
			name: 'CrossFeet',
			lable: '交叉步',
			type: '1'
		},
		{
			name: 'Glissade',
			lable: '滑步',
			type: '1'
		},
		{
			name: 'FrontSlidingStep',
			lable: '前滑步',
			type: '1'
		},
		{
			name: 'SideSlide',
			lable: '侧滑步',
			type: '1'
		},
		{
			name: 'HandKneeClimbing',
			lable: '手膝爬',
			type: '1'
		},
		{
			name: 'HandFootCrawling',
			lable: '手脚爬',
			type: '1'
		},
		{
			name: 'Crawl',
			lable: '匍匐爬',
			type: '1'
		},
		{
			name: 'JumpFromHeight',
			lable: '从高处跳下',
			type: '1'
		},
		{
			name: 'JumpHigh',
			lable: '向高处跳',
			type: '1'
		},
		{
			name: 'FeetLongJump',
			lable: '双脚跳远',
			type: '1'
		},
		{
			name: 'Throw',
			lable: '投掷',
			type: '2'
		},
		{
			name: 'ThrowBallOnTheGround',
			lable: '抛掷地滚球',
			type: '2'
		},
		{
			name: 'LowHandThrow',
			lable: '低手投掷',
			type: '2'
		},
		{
			name: 'HandThrow',
			lable: '双手投掷',
			type: '2'
		},
		{
			name: 'OneHandedShoulderThrow',
			lable: '单手肩上投掷',
			type: '2'
		},
		{
			name: 'Embrace',
			lable: '抱',
			type: '2'
		},
		{
			name: 'Raise',
			lable: '抬',
			type: '2'
		},
		{
			name: 'Carry',
			lable: '端',
			type: '2'
		},
		{
			name: 'Press',
			lable: '压',
			type: '2'
		},
		{
			name: 'Shove',
			lable: '推',
			type: '2'
		},
		{
			name: 'Pull',
			lable: '拉',
			type: '2'
		},
		{
			name: 'Prehension',
			lable: '抓握',
			type: '2'
		},
		{
			name: 'HoldUp',
			lable: '举',
			type: '2'
		},
		{
			name: 'TumblingObject',
			lable: '翻滚物体',
			type: '2'
		},
		{
			name: 'RollingObject',
			lable: '滚动物体',
			type: '2'
		},
		{
			name: 'BounceBall',
			lable: '拍球',
			type: '2'
		},
		{
			name: 'Kick',
			lable: '踢',
			type: '2'
		},
		{
			name: 'KickFixedBall',
			lable: '脚踢固定球',
			type: '2'
		},
		{
			name: 'FootDribble',
			lable: '脚运球',
			type: '2'
		},
		{
			name: 'CatchBall',
			lable: '接球',
			type: '2'
		},
		{
			name: 'Impact',
			lable: '击打',
			type: '2'
		},
		{
			name: 'ShoulderStrike',
			lable: '肩上击打',
			type: '2'
		},
		{
			name: 'BothHandsHitSideways',
			lable: '双手体侧击打',
			type: '2'
		},
		{
			name: 'JumpLowFromHigh',
			lable: '从高处向低处跳',
			type: '3'
		},
		{
			name: 'JumpHighLower',
			lable: '低处向高处跳',
			type: '3'
		},
		{
			name: 'Squat',
			lable: '下蹲',
			type: '3'
		},
		{
			name: 'BalancedWalk',
			lable: '平衡行走',
			type: '3'
		},
		{
			name: 'BalanceStand',
			lable: '燕式平衡',
			type: '3'
		},
		{
			name: 'StandOneLeg',
			lable: '单脚站立',
			type: '3'
		},
		{
			name: 'BendingStretching',
			lable: '弯曲与伸展',
			type: '3'
		},
		{
			name: 'LateralTorsion',
			lable: '侧扭转',
			type: '3'
		},
		{
			name: 'BendingStanding',
			lable: '弯曲与直立',
			type: '3'
		},
		{
			name: 'TransportObject',
			lable: '搬运物体',
			type: '3'
		},
		{
			name: 'DynamicBalanc',
			lable: '动态平衡',
			type: '3'
		},
		{
			name: 'StaticBalanc',
			lable: '静态平衡',
			type: '3'
		},
		{
			name: 'BendingCrimp',
			lable: '弯曲与卷曲',
			type: '3'
		},
		{
			name: 'Turn',
			lable: '转体',
			type: '3'
		},
		{
			name: 'TurnRound',
			lable: '扭转',
			type: '3'
		},
		{
			name: 'Stretch',
			lable: '伸展',
			type: '3'
		},
		{
			name: 'ShiftCenterGravity',
			lable: '转移重心',
			type: '3'
		}
	],

	coursesPage: [
		{
			Label: "走",
			Name: "Walk",
			Result: "",
			Type: 11,
		},
		{
			Label: "跑",
			Name: "Run",
			Result: "",
			Type: 11,
		},
		{
			Label: "障碍跑",
			Name: "ObstacleRun",
			Result: "",
			Type: 11,
		},
		{
			Label: "变向跑",
			Name: "ReverseRun",
			Result: "",
			Type: 11,
		},
		{
			Label: "双脚跳",
			Name: "SkipJump",
			Result: "",
			Type: 11,
		},
		{
			Label: "跨跳",
			Name: "StepJump",
			Result: "",
			Type: 11,
		},
		{
			Label: "钻",
			Name: "Bore",
			Result: "",
			Type: 11,
		},
		{
			Label: "侧身钻",
			Name: "SideDrill",
			Result: "",
			Type: 11,
		},
		{
			Label: "正面钻",
			Name: "FrontDrill",
			Result: "",
			Type: 11,
		},
		{
			Label: "交叉步",
			Name: "CrossFeet",
			Result: "",
			Type: 11,
		},
		{
			Label: "滑步",
			Name: "Glissade",
			Result: "",
			Type: 11,
		},
		{
			Label: "前滑步",
			Name: "FrontSlidingStep",
			Result: "",
			Type: 11,
		},
		{
			Label: "侧滑步",
			Name: "SideSlide",
			Result: "",
			Type: 11,
		},
		{
			Label: "手膝爬",
			Name: "HandKneeClimbing",
			Result: "",
			Type: 11,
		},
		{
			Label: "手脚爬",
			Name: "HandFootCrawling",
			Result: "",
			Type: 11,
		},
		{
			Label: "匍匐爬",
			Name: "Crawl",
			Result: "",
			Type: 11,
		},
		{
			Label: "从高处跳下",
			Name: "JumpFromHeight",
			Result: "",
			Type: 11,
		},
		{
			Label: "向高处跳",
			Name: "JumpHigh",
			Result: "",
			Type: 11,
		},
		{
			Label: "双脚跳远",
			Name: "FeetLongJump",
			Result: "",
			Type: 11,
		}, {
			Label: "单脚跳",
			Name: "Hop",
			Result: "",
			Type: 11,
		},
		{
			Label: "投掷",
			Name: "Throw",
			Result: "",
			Type: 22,
		},
		{
			Label: "抛掷地滚球",
			Name: "ThrowBallOnTheGround",
			Result: "",
			Type: 22,
		},
		{
			Label: "低手投掷",
			Name: "LowHandThrow",
			Result: "",
			Type: 22,
		},
		{
			Label: "双手投掷",
			Name: "HandThrow",
			Result: "",
			Type: 22,
		},
		{
			Label: "单手肩上投掷",
			Name: "OneHandedShoulderThrow",
			Result: "",
			Type: 22,
		},
		{
			Label: "抱",
			Name: "Embrace",
			Result: "",
			Type: 22,
		},
		{
			Label: "抬",
			Name: "Raise",
			Result: "",
			Type: 22,
		},
		{
			Label: "端",
			Name: "Carry",
			Result: "",
			Type: 22,
		},
		{
			Label: "压",
			Name: "Press",
			Result: "",
			Type: 22,
		},
		{
			Label: "推",
			Name: "Shove",
			Result: "",
			Type: 22,
		},
		{
			Label: "拉",
			Name: "Pull",
			Result: "",
			Type: 22,
		},
		{
			Label: "抓握",
			Name: "Prehension",
			Result: "",
			Type: 22,
		},
		{
			Label: "举",
			Name: "HoldUp",
			Result: "",
			Type: 22,
		},
		{
			Label: "翻滚物体",
			Name: "TumblingObject",
			Result: "",
			Type: 22,
		},
		{
			Label: "滚动物体",
			Name: "RollingObject",
			Result: "",
			Type: 22,
		},
		{
			Label: "拍球",
			Name: "BounceBall",
			Result: "",
			Type: 22,
		},
		{
			Label: "踢",
			Name: "Kick",
			Result: "",
			Type: 22,
		},
		{
			Label: "脚踢固定球",
			Name: "KickFixedBall",
			Result: "",
			Type: 22,
		},
		{
			Label: "脚运球",
			Name: "FootDribble",
			Result: "",
			Type: 22,
		},
		{
			Label: "接球",
			Name: "CatchBall",
			Result: "",
			Type: 22,
		},
		{
			Label: "击打",
			Name: "Impact",
			Result: "",
			Type: 22,
		},
		{
			Label: "肩上击打",
			Name: "ShoulderStrike",
			Result: "",
			Type: 22,
		},
		{
			Label: "双手体侧击打",
			Name: "BothHandsHitSideways",
			Result: "",
			Type: 22,
		},
		{
			Label: "从高处向低处跳",
			Name: "JumpLowFromHigh",
			Result: "",
			Type: 33
		},
		{
			Label: "从低处向高处跳",
			Name: "JumpHighLower",
			Result: "",
			Type: 33
		},
		{
			Label: "下蹲",
			Name: "Squat",
			Result: "",
			Type: 33
		},
		{
			Label: "平衡行走",
			Name: "BalancedWalk",
			Result: "",
			Type: 33
		},
		{
			Label: "燕式平衡",
			Name: "BalanceStand",
			Result: "",
			Type: 33
		},
		{
			Label: "单脚站立",
			Name: "StandOneLeg",
			Result: "",
			Type: 33
		},
		{
			Label: "弯曲与伸展",
			Name: "BendingStretching",
			Result: "",
			Type: 33
		},
		{
			Label: "侧扭转",
			Name: "LateralTorsion",
			Result: "",
			Type: 33
		},
		{
			Label: "弯曲与直立",
			Name: "BendingStanding",
			Result: "",
			Type: 33
		},
		{
			Label: "搬运物体",
			Name: "TransportObject",
			Result: "",
			Type: 33
		},
		{
			Label: "动态平衡",
			Name: "DynamicBalanc",
			Result: "",
			Type: 33
		},
		{
			Label: "静态平衡",
			Name: "StaticBalanc",
			Result: "",
			Type: 33
		},
		{
			Label: "弯曲与卷曲",
			Name: "BendingCrimp",
			Result: "",
			Type: 33
		},
		{
			Label: "转体",
			Name: "Turn",
			Result: "",
			Type: 33
		},
		{
			Label: "扭转",
			Name: "TurnRound",
			Result: "",
			Type: 33
		},
		{
			Label: "伸展",
			Name: "Stretch",
			Result: "",
			Type: 33
		},
		{
			Label: "转移重心",
			Name: "ShiftCenterGravity",
			Result: "",
			Type: 33
		},
		{
			Label: "平衡",
			Name: "Balance",
			Result: '',
			Type: 44
		}, {
			Label: "协调",
			Name: "Coordinate",
			Result: '',
			Type: 44
		}, {
			Label: "灵敏",
			Name: "Sensitive",
			Result: '',
			Type: 44
		}, {
			Label: "柔韧",
			Name: "Flexible",
			Result: '',
			Type: 44
		}, {
			Label: "上肢力量",
			Name: "UpperLimbStrength",
			Result: '',
			Type: 44
		}, {
			Label: "下肢力量",
			Name: "LowerLimbStrength",
			Result: '',
			Type: 44
		},
		{
			Label: "同伴交往",
			Name: "Association",
			Type: 55,
			Result: '',

		}, {
			Label: "规则意识",
			Name: "RuleConsciousness",
			Type: 55,
			Result: '',
		}, {
			Label: "团队协作",
			Name: "Teamwork",
			Type: 55,
			Result: '',
		}, {
			Label: "竞争意识",
			Name: "Competitive",
			Type: 55,
			Result: '',
		}, {
			Label: "运动习惯",
			Name: "ExerciseHabit",
			Type: 55,
			Result: '',
		},
		{
			Label: "方向",
			Name: "Direction",
			Result: "",
			Type: 66
		},
		{
			Label: "高度",
			Name: "Altitude",
			Result: "",
			Type: 66
		},
		{
			Label: "重量",
			Name: "Heft",
			Result: "",
			Type: 66
		},
		{
			Label: "重力",
			Name: "Gravity",
			Result: "",
			Type: 66
		},
		{
			Label: "空间",
			Name: "Space",
			Result: "",
			Type: 66
		},
		{
			Label: "颜色",
			Name: "Colour",
			Result: "",
			Type: 66
		},
		{
			Label: "形状",
			Name: "Form",
			Result: "",
			Type: 66
		},
		{
			Label: "长度",
			Name: "Longness",
			Result: "",
			Type: 66
		},
		{
			Label: "本体感觉",
			Name: "Proprioception",
			Result: "",
			Type: 66
		}




		// {
		// 	Label:"跑步",
		// 	Name: "Run",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"跳跃",
		// 	Name: "Jump",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"行走",
		// 	Name: "Walk",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"钻",
		// 	Name: "Bore",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"爬",
		// 	Name: "Creep",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"翻滚",
		// 	Name: "Roll",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"跨越",
		// 	Name: "StrideAcross",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"滑步",
		// 	Name: "Glissade",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"攀登",
		// 	Name: "Climb",
		// 	Result:'',
		// 	Type:11
		// },{
		// 	Label:"投掷",
		// 	Name: "Throw",
		// 	Result:'',
		// 	Type:22
		// },{
		// 	Label:"拍球",
		// 	Name: "BounceBall",
		// 	Result:'',
		// 	Type:22
		// },{
		// 	Label:"传球",
		// 	Name: "TransmissionConnection",
		// 	Result:'',
		// 	Type:22
		// },{
		// 	Label:"打击",
		// 	Name: "Impact",
		// 	Result:'',
		// 	Type:22
		// },{
		// 	Label:"踢",
		// 	Name: "Kick",
		// 	Result:'',
		// 	Type:22
		// },{
		// 	Label:"抓握",
		// 	Name: "Prehension",
		// 	Result:'',
		// 	Type:22
		// },{
		// 	Label:"弯曲",
		// 	Name: "Winding",
		// 	Result:'',
		// 	Type:33
		// },{
		// 	Label:"转体",
		// 	Name: "Turn",
		// 	Result:'',
		// 	Type:33
		// },{
		// 	Label:"伸展",
		// 	Name: "Spread",
		// 	Result:''
		// },{
		// 	Label:"直立",
		// 	Name: "Endlong",
		// 	Result:'',
		// 	Type:33
		// },
		// {
		// 	Label:"平衡",
		// 	Name: "Balance",
		// 	Result:'',
		// 	Type:44
		// },{
		// 	Label:"协调",
		// 	Name: "Coordinate",
		// 	Result:'',
		// 	Type:44
		// },{
		// 	Label:"灵敏",
		// 	Name: "Sensitive",
		// 	Result:'',
		// 	Type:44
		// },{
		// 	Label:"柔韧",
		// 	Name: "Flexible",
		// 	Result:'',
		// 	Type:44
		// },{
		// 	Label:"上肢力量",
		// 	Name: "UpperLimbStrength",
		// 	Result:'',
		// 	Type:44
		// },{
		// 	Label:"下肢力量",
		// 	Name: "LowerLimbStrength",
		// 	Result:'',
		// 	Type:44
		// },
		// {
		// 	Label:"同伴交往",
		// 	Name: "Association",
		// 	Type:55,
		// 	Result:'',
		//
		// },{
		// 	Label:"规则意识",
		// 	Name: "RuleConsciousness",
		// 	Type:55,
		// 	Result:'',
		// },{
		// 	Label:"团队协作",
		// 	Name: "Teamwork",
		// 	Type:55,
		// 	Result:'',
		// },{
		// 	Label:"竞争意识",
		// 	Name: "Competitive",
		// 	Type:55,
		// 	Result:'',
		// },{
		// 	Label:"运动习惯",
		// 	Name: "ExerciseHabit",
		// 	Type:55,
		// 	Result:'',
		// }
	],

	courseFrom: {
		Run: '',
		Jump: '',
		Walk: '',
		Bore: '',
		Creep: '',
		Roll: '',
		StrideAcross: '',
		Glissade: '',
		Climb: '',
		Throw: '',
		BounceBall: '',
		TransmissionConnection: '',
		Impact: '',
		Kick: '',
		Prehension: '',
		Winding: '',
		Turn: '',
		Spread: '',
		Endlong: '',
		Balance: '',
		Coordinate: '',
		Sensitive: '',
		Flexible: '',
		UpperLimbStrength: '',
		LowerLimbStrength: '',
		Association: '',
		RuleConsciousness: '',
		Teamwork: '',
		Competitive: '',
		ExerciseHabit: ''
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js